import './App.css';
import Footer from './components/footer';
import Header from './components/header';

function App() {
  return (
    <div>
      <Header/>
      <div id='dialog'>
      <h1>Coming Soon....</h1>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
